import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/api/client";
import type {
  ServiceUserKey,
  ServiceUserKeyCreate,
  ServiceUserKeyCreated,
} from "@/api/types";

const keysKey = (id: string) => ["service-users", id, "keys"] as const;

export function useServiceUserApiKeys(id: string) {
  return useQuery({
    queryKey: keysKey(id),
    queryFn: () => api.GET<ServiceUserKey[]>(`/service-users/${id}/keys`),
    enabled: Boolean(id),
  });
}

export function useCreateServiceUserApiKey(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: ServiceUserKeyCreate) =>
      api.POST<ServiceUserKeyCreated>(`/service-users/${id}/keys`, payload),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: keysKey(id) });
    },
  });
}

export function useRevokeServiceUserApiKey(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (keyId: string) =>
      api.DELETE<void>(`/service-users/${id}/keys/${keyId}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: keysKey(id) });
    },
  });
}
